export enum MarketStatus {
	Queue = 'queue',
	Open = 'open',
	Settled = 'settled',
	Closed = 'closed',
	Live = 'live',
	Void = 'void',
	SecondChance = 'second-chance',
}
